import { Component } from '@angular/core'

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>

    <chat-image-viewer></chat-image-viewer>
  `,
})
export class AppComponent {}
